// extracted by mini-css-extract-plugin
export default {"button":"RepliesIcon-module__button","icon":"RepliesIcon-module__icon","count":"RepliesIcon-module__count"};